import { Component } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { TemplateComponent } from '@shared/components/template/template.component';
import { SorryPage } from '@shared/models';

@Component({
  selector: 'b2c-sorry',
  imports: [TemplateComponent],
  styleUrl: './sorry.component.scss',
  templateUrl: './sorry.component.html',
})
export class SorryComponent extends BaseComponent {
  public config: SorryPage = this.loyaltyChallengeConfig.pages.sorry;
}
